module.exports = __webpack_public_path__ + "static/img/hatchet.4f42659.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/carousel/hatchet.jpg
// module id = JEFz
// module chunks = 1